import React from 'react';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { RouteComponentProps } from 'react-router';
import { IStore } from 'reducers/index';
import { fetchFCRDetails } from 'actions/fcr';
import { ErrorDialog } from 'components/error-dialog';
import { IDocumentDetail } from 'reducers/fcr/models';
import API from 'constants/api';
import { IMaterialList } from 'reducers/materialMaster';
import { PageHeader } from 'components/page-header';
import { TabComponent } from 'components/sub-navigation/components/TabComponent';
import { calculateTotalOfField, generateDistributionData } from 'views/job-costing/utils/CostAndRevenueHelpers';
import { CostAndRevenue } from 'modules/cost-revenue/component/CostAndRevenue';
import DocumentDetails from './DocumentDetails';
import { DetailsTopBar } from './DetailsTopBar';
import {
    navLinksFCR,
    voyagesCols,
    equipmentTransportShipmentsCols,
    cblCols,
    bookingsCols,
    equipmentColsDocs,
    customerInvoiceCols,
    clrCols
} from 'constants/tableConstants';
import { withRouter } from 'react-router-dom';
import { formatValueIfNullOrUndefined, clearFormat, formatDate, isFeatureEnabled, simplifyNull } from 'utilities/util';
import CostColumnsData from 'views/job-costing/utils/CostColumnsData';
import { HeaderWrapper } from 'components/cost-revenue/HeaderWrapper';
import InPageDialog from '../../../../components/page-dialog';
import { Partners } from 'modules/partners/Partners';
import { HistoryLog } from 'modules/history/HistoryLog';
import * as ValidationMessages from 'constants/validationMessages';
import { FinOpsStatus } from 'views/job-costing/utils/models';
import { LoadingAnimation } from 'components/loading';
import { IFeatureToggleModel } from 'reducers/featureToggle/models';
import { FEATURE_TOGGLES } from 'constants/featureToggles';
import { localCurrency } from 'constants/customs';
import { fetchCostAndRevenue } from 'actions/costRevenue';
import { IResponse } from 'reducers/bookings/models';
import { fetchNftpBillable } from 'actions/exportJob';
import { isNftpRoeEnabled, calculateActualTotal } from 'utilities/nftp';
interface IParams {
    documentId: string;
    exportjobId: string;
}
interface IMapDispatchToProps {
    fetchFCRDetails: (documentId: number) => Promise<void>;
    fetchCostAndRevenue: (type: number, valueId: any[], targetType: string) => Promise<void>;
    fetchNftpBillable: (jobId: number) => Promise<void>;
}
interface IMapStateToProps {
    documentDetails: IDocumentDetail;
    isLoading: boolean;
    isFetchDataError: boolean;
    detailsPendingError: string,
    update: string,
    materialMasterList: IMaterialList[];
    invoicedResponse: any;
    submitInvoiceError: boolean;
    resendResponse: string,
    resendLoading: boolean,
    resendError: string | string[],
    isResendError: boolean,
    featureToggles: IFeatureToggleModel[],
    costAndrevenueresponse: IResponse;
    isNftpBillable: boolean | undefined;
    isNftpBillableLoading: boolean;
}
interface IDocCharges extends RouteComponentProps<IParams>, IMapDispatchToProps, IMapStateToProps { }
interface IState {
    activeTab: number,
    disableTab: boolean,
    hasError: boolean,
    totalRevenue: string,
    totalCost: string,
    showDialog: boolean,
    wasSubmitted: boolean,
    confirmDialogVisible: boolean,
    isSuccess: boolean,
    pendingError: string,
    status: string[] | null;
    isNftpRoeEnabled?: boolean;
    isNftpRoeEnabledLoading?: boolean; 
    actualRevenue?: string;
    actualCost?: string;
}
export class _ChargesDocumentDetails extends React.Component<IDocCharges, IState> {
    constructor(props: IDocCharges) {
        super(props);
        this.state = this.initialState();
    }

    public componentDidMount() {
        this.props.fetchFCRDetails(Number(this.props.match.params.documentId));
        if (this.props.match.params.exportjobId) {
            this.props.fetchCostAndRevenue(4, [Number(this.props.match.params.exportjobId)], 'origin');
        }
    }

    public fetchNftpBillable = async (exportJobId: number) => {
        const isNftpApplicable = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_NFTP_SALESORDER_REQ_EXPORT, this.props.featureToggles);
        if (isNftpApplicable) {
            await this.props.fetchNftpBillable(Number(exportJobId));
        }
    }

    public componentWillUnmount() {
        this.setState(this.initialState());
    }
    public initialState = (): IState => {
        return {
            activeTab: 0,
            isSuccess: false,
            disableTab: false,
            showDialog: false,
            wasSubmitted: false,
            confirmDialogVisible: false,
            totalRevenue: '0',
            totalCost: '0',
            pendingError: '',
            status: null,
            hasError: false,
            isNftpRoeEnabled: false,
            isNftpRoeEnabledLoading: true,
            actualRevenue: '0',
            actualCost: '0'

        };
    };
    public async componentDidUpdate(props: any) {
        if (!this.props.match.params.exportjobId) {
            const prevExportJobId = props.documentDetails?.exportJobId;
            const currExportJobId = this.props.documentDetails?.exportJobId;

            if (currExportJobId && currExportJobId !== 0 && prevExportJobId !== currExportJobId) {
                this.props.fetchCostAndRevenue(4, [Number(currExportJobId)], 'origin');
                if (currExportJobId && isFeatureEnabled(FEATURE_TOGGLES.FINOPS_NFTP_SALESORDER_REQ_EXPORT, this.props.featureToggles)) {
                    await this.props.fetchNftpBillable(Number(currExportJobId));
                }
                this.setState({ isNftpRoeEnabled: isNftpRoeEnabled(this.props.isNftpBillable ?? false, this.props.featureToggles) });
                this.setState({ isNftpRoeEnabledLoading: false});
                this.getActualTotal();
            }
        }

        if (this.props.invoicedResponse !== props.invoicedResponse) {
            if (!this.props.submitInvoiceError && this.props.invoicedResponse.length > 0) {
                let resp = '';
                this.props.invoicedResponse.forEach((entry: any) => {
                    resp += `${entry.finOpsInvoiceNumber}, sent to ${entry.email ? entry.email : entry.printerName}. `;
                });
                this.setState({
                    showDialog: true,
                    isSuccess: true,
                    pendingError: `Successfully issued invoice: ${resp}`
                }, () => {
                    this.props.fetchFCRDetails(Number(this.props.match.params.documentId));
                });
            } else {
                this.setState({
                    showDialog: true,
                    isSuccess: false,
                    pendingError: this.props.invoicedResponse ? this.props.invoicedResponse : 'Failed to create an Invoice'
                });
            }
        }
        if (this.props.resendResponse !== props.resendResponse) {
            if (!this.props.isResendError && this.props.resendResponse) {
                this.setState({
                    showDialog: true,
                    isSuccess: true,
                    pendingError: `Successfully resent message to SAP`
                });
            } else if (this.props.isResendError && this.props.resendError) {
                this.setState({
                    showDialog: true,
                    isSuccess: false,
                    pendingError: 'Failed to resend message to SAP'
                });
            }
        }
        if (props.isFetchDataError !== this.props.isFetchDataError &&
            this.props.isFetchDataError === true && this.props.detailsPendingError) {
            let checkText: string | string[] = props.detailsPendingError;
            if ((Array.isArray(this.props.detailsPendingError) &&
                this.props.detailsPendingError.length === 0) ||
                this.props.detailsPendingError === '') {
                checkText = 'Server Error. Try again later.';
            }
            this.setState({ isSuccess: false, showDialog: true, pendingError: checkText.toString() });
        }
        if (this.props.documentDetails && this.props.documentDetails.rateErrorMessage !== props.documentDetails.rateErrorMessage) {
            const handleError = (error: string): boolean => {
                if (error) {
                    this.setState({ isSuccess: false, showDialog: true, pendingError: error.toString().replace(/\|/g, '\n') });
                    return true;
                }
                return false;
            };
            const hasError: boolean = this.props.documentDetails && this.props.documentDetails.rateErrorMessage ? handleError(this.props.documentDetails.rateErrorMessage) : false;
            this.setState({
                hasError,
                isSuccess: !hasError
            });
        }
        if (this.props.update && this.props.update !== props.update) {
            if (this.props.isFetchDataError) {
                this.setState({ isSuccess: false, showDialog: true, pendingError: this.props.update });
            } else {
                this.setState({ isSuccess: true, showDialog: true, pendingError: this.props.update });
                setTimeout(() => {
                    this.props.fetchFCRDetails(Number(this.props.match.params.documentId));
                }, 500);
            }
        }
        if (this.props.documentDetails && this.props.documentDetails.finOpsStatus !== props.documentDetails.finOpsStatus) {
            const status: string[] = this.props.documentDetails && this.props.documentDetails.finOpsStatus ? [this.props.documentDetails.finOpsStatus] : [];
            this.setState({
                status
            });
        }
    }
    public getActualTotal = () => {
        const rateDetailsList = this.props.costAndrevenueresponse.result[0]?.essoRateDetailsModels || [];
        const actualRevenue = calculateActualTotal(rateDetailsList, CostColumnsData.TYPES.REVENUE);
        const actualCost = calculateActualTotal(rateDetailsList, CostColumnsData.TYPES.COST);
        this.setState({ actualRevenue, actualCost }) ;
    };
    public checkShowInvoices = (): boolean => {
        const resp = Boolean((this.props.documentDetails.finOpsStatus) &&
            (this.props.documentDetails.finOpsStatus === FinOpsStatus.partialInvoiced ||
                this.props.documentDetails.finOpsStatus === FinOpsStatus.partialSettled ||
                this.props.documentDetails.finOpsStatus === FinOpsStatus.salesOrderCreated ||
                this.props.documentDetails.finOpsStatus === FinOpsStatus.salesOrderUpdated)) &&
            Boolean(this.props.documentDetails.opsStatus) &&
            Boolean(this.props.documentDetails.opsStatus !== 'DraftApprovedRejected') &&
            Boolean(this.props.documentDetails.salesOrderNumber) &&
            Boolean(this.props.documentDetails.consigneeFactCode) &&
            !Boolean(this.props.documentDetails.rateErrorMessage);
        return resp;
    };

    public render() {
        const isExtraDocumentFeatureEnabled = isFeatureEnabled(FEATURE_TOGGLES.EXTRA_DOCUMENT, this.props.featureToggles);
        const isHblConsumptionEnabled = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_HBL_CONSUMPTION, this.props.featureToggles);
        return (
            <React.Fragment>
                {this.props.isLoading && <LoadingAnimation />}
                <ErrorDialog endpoint={API.FCR.FcrDetails} />
                {this.props.documentDetails && this.props.documentDetails.exportJobNumber && <PageHeader backButton={true}
                    displayConfirm={this.state.disableTab}
                    confirmMessage={this.state.disableTab ? ValidationMessages.CostAndRevenue.Alert_Page_Exit : ''}
                    id="fcr-details">{isExtraDocumentFeatureEnabled ? 'Document Number' : (isHblConsumptionEnabled ? 'FCR/HBL Number' : 'FCR Number')}: {this.props.documentDetails.originalDocumentNumber}
                </PageHeader>}
                {this.state.showDialog && <div className={'padding-bottom-large padding-left-large padding-right-large'}><InPageDialog
                    showDialog={this.state.showDialog}
                    type={this.state.isSuccess ? 'success' : 'error'}
                    message={this.state.pendingError}
                    closeMethod={() => this.setState({ showDialog: false, isSuccess: false })} /></div>}
                <HeaderWrapper
                    firstValue={this.props.documentDetails.opsStatus}
                    secondValue={this.props.documentDetails.finOpsStatus}
                    thirdValue={this.props.documentDetails.incoTerms}
                    forthValue={formatDate(this.props.documentDetails.lastUpdateDate)}
                    fifthValue={this.props.documentDetails.prepaidCollectIndicator}
                    statusColor={this.state.hasError ? 'red' : ''}
                    target={1}
                    totals={{
                        firstRow: { label: 'Total Revenue', value: this.state.totalRevenue, actualValue: this.state.actualRevenue },
                        secondRow: { label: 'Total Cost', value: this.state.totalCost, actualValue: this.state.actualCost },
                        lastRow: { label: 'Profitability' },
                        isNftpRoeEnabled: this.state.isNftpRoeEnabled
                    }}
                />
                <DetailsTopBar
                    number={this.props.documentDetails.exportJobNumber}
                    incoTerm={this.props.documentDetails.incoTerm}
                    shipmentType={this.props.documentDetails.shipmentType}
                    originService={this.props.documentDetails.serviceAtOrigin}
                    destinationService={this.props.documentDetails.serviceAtDestination}
                    etd={this.props.documentDetails.etd}
                    portOfDischargeCode={this.props.documentDetails.portOfDischargeCode}
                    placeOfReceiptCode={this.props.documentDetails.placeOfReceiptCode}
                    portOfLoadingCode={this.props.documentDetails.portOfLoadingCode}
                    placeOfDeliveryCode={this.props.documentDetails.placeOfDeliveryCode}
                    soNumber={this.props.isNftpBillable ? '' : this.props.documentDetails.salesOrderNumber}
                    isExtraDocumentFeatureEnabled={isExtraDocumentFeatureEnabled}
                />
                <div className="padding-left-large padding-right-large">
                    <TabComponent name="documents" navLinks={navLinksFCR(isExtraDocumentFeatureEnabled, isHblConsumptionEnabled)}
                        callbackFc={(e: number) => this.setState({ activeTab: e - 1 })}
                        isDisabled={this.state.disableTab}
                        activeTab={this.state.activeTab} >
                        {!this.props.isNftpBillableLoading && !this.state.isNftpRoeEnabledLoading && this.props.documentDetails.exportJobNumber && this.props.costAndrevenueresponse.result.length > 0 && <CostAndRevenue
                            targetType="origin"
                            toggleTabs={(b: boolean) => this.setState({ disableTab: b })}
                            fStatus={[this.props.documentDetails.finOpsStatus]}
                            targetId={4}
                            showInvoices={this.checkShowInvoices()}
                            invoicesData={{
                                consignee: this.props.documentDetails.consigneeFactCode,
                                companyCode: this.props.documentDetails.companyCode,
                                billingCurrency: this.props.documentDetails.salesDocumentCurrency,
                                salesArea: this.props.documentDetails.salesArea,
                                fcrNumber: this.props.documentDetails.originalDocumentNumber,
                                fcrId: this.props.documentDetails.exportJobId,
                            }}
                            partyData={{
                                country: this.props.documentDetails.issuerCountryCode,
                                company: this.props.documentDetails.companyCode,
                                purchase: this.props.documentDetails.purchaseOrganisation
                            }}
                            costAndrevenueresponse={this.props.costAndrevenueresponse}
                            distributionData={generateDistributionData(this.props.documentDetails)}
                            readOnly={true}
                            splitCols={CostColumnsData.getCostFCRSubCols()}
                            docId={Number(this.props.documentDetails.exportJobId)}
                            costAndRevenueId={Number(this.props.documentDetails.exportJobId)}
                            navigateTo={(url: string) => this.props.history.push(url)}
                            eventCallback={() => this.setState({ showDialog: false, pendingError: '' })}
                            isNftpBillable = {this.props.isNftpBillable}
                            isNftpRoeEnabled = {this.state.isNftpRoeEnabled}
                            outputCostRev={(cost: any[], revenue: any[]) => {
                                this.setState({ totalCost: clearFormat(calculateTotalOfField(cost, localCurrency.totalLocalCurrency)) });
                                this.setState({ totalRevenue: clearFormat(calculateTotalOfField(revenue, localCurrency.totalLocalCurrency)) });
                            }} />}
                        <DocumentDetails
                            organisation={[
                                { label: 'Company Code', value: formatValueIfNullOrUndefined(this.props.documentDetails.companyCode) },
                                { label: 'Sales Area', value: formatValueIfNullOrUndefined(this.props.documentDetails.salesArea) },
                                { label: 'Origin Office', value: simplifyNull(this.props.documentDetails.bookings[0]?.officeCode, this.props.documentDetails.bookings[0]?.originSiteName) },
                                { label: 'Destination Office', value: simplifyNull(this.props.documentDetails.bookings[0]?.destinationSiteCode, this.props.documentDetails.bookings[0]?.destinationSiteName) },
                                { label: 'Sales Document Currency', value: formatValueIfNullOrUndefined(this.props.documentDetails.salesDocumentCurrency) },
                                { label: 'Sales Document Net Value', value: formatValueIfNullOrUndefined(this.props.documentDetails.salesDocumentNetValue) },
                                { label: 'Sales Document Type', value: formatValueIfNullOrUndefined(this.props.documentDetails.salesDocumentType) },
                                { label: 'Create Date', value: formatDate(this.props.documentDetails.createDate, 'YYYY-MM-DD HH:mm:ss') }
                            ]}
                            locations={[
                                { label: 'Place of receipt code', value: formatValueIfNullOrUndefined(this.props.documentDetails.placeOfReceiptCode) },
                                { label: 'Port of loading code', value: formatValueIfNullOrUndefined(this.props.documentDetails.portOfLoadingCode) },
                                { label: 'Port of discharge code', value: formatValueIfNullOrUndefined(this.props.documentDetails.portOfDischargeCode) },
                                { label: 'Place of delivery code', value: formatValueIfNullOrUndefined(this.props.documentDetails.placeOfDeliveryCode) },
                                { label: 'Place of receipt name', value: formatValueIfNullOrUndefined(this.props.documentDetails.placeOfReceiptName) },
                                { label: 'Port of loading name', value: formatValueIfNullOrUndefined(this.props.documentDetails.portOfLoadingName) },
                                { label: 'Port of discharge name', value: formatValueIfNullOrUndefined(this.props.documentDetails.portOfDischargeName) },
                                { label: 'Place of delivery name', value: formatValueIfNullOrUndefined(this.props.documentDetails.placeOfDeliveryName) },
                            ]}
                            cargoDetails={[
                                { label: 'Quantity', value: formatValueIfNullOrUndefined(this.props.documentDetails.quantity) },
                                { label: 'Package', value: formatValueIfNullOrUndefined(this.props.documentDetails.packages) },
                                { label: 'Volume (m3)', value: formatValueIfNullOrUndefined(clearFormat(this.props.documentDetails.volume, 3)) },
                                { label: 'Weight', value: formatValueIfNullOrUndefined(clearFormat(this.props.documentDetails.weight, 3)) },
                            ]}
                            jobIdDetails={[
                                {
                                    label: 'Export', value: !this.props.documentDetails.finNumber ? formatValueIfNullOrUndefined('') :
                                        <a onClick={() => { this.props.history.push(`/job-costing/exportjobs/${this.props.documentDetails.exportJobId}`); }}>{this.props.documentDetails.finNumber}</a>
                                },
                                { label: 'Import', value: formatValueIfNullOrUndefined('') }
                            ]}
                            link={(url: string) => { this.props.history.push(url); }}
                            bookings={{ data: this.props.documentDetails.bookings, cols: bookingsCols, name: 'fcr-bookings-' }}
                            cbl={{ data: this.props.documentDetails.cbls, cols: cblCols, name: 'fcr-cbls-' }}
                            clr={{ data: this.props.documentDetails.clrs, cols: clrCols, name: 'fcr-cbls-' }}
                            equipments={{ data: this.props.documentDetails.equipments, cols: equipmentColsDocs, name: 'fcr-billingDocuments-' }}
                            equipmentTransportShipments={{ data: this.props.documentDetails.equipmentTransportShipments, cols: equipmentTransportShipmentsCols, name: 'fcr-equipmentTransportShipments-' }}
                            voyages={{ data: this.props.documentDetails.voyages, cols: voyagesCols, name: 'fcr-voyages-' }}
                            customerInvoice={{ data: this.props.documentDetails.billingDocuments, cols: customerInvoiceCols, name: 'fcr-customerInvoice-' }}
                            isExtraDocumentFeatureEnabled={isExtraDocumentFeatureEnabled}
                        />
                        {this.state.activeTab === 2 && <Partners isVisible={this.state.activeTab === 2} target={4} targetId={this.props.documentDetails.exportJobId} />}
                        {this.state.activeTab === 3 && <HistoryLog shipmentId={this.props.documentDetails.exportJobId.toString()} shipmentType={4} />}
                    </TabComponent>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: IStore): IMapStateToProps => ({
    documentDetails: state.fcr.documentDetails,
    isLoading: state.fcr.isFetchDataLoading,
    isFetchDataError: state.fcr.isFetchDataError,
    detailsPendingError: state.fcr.detailsPendingError,
    materialMasterList: state.materialMaster.materialMasterList,
    update: state.costRevenue.update,
    invoicedResponse: state.invoices.invoicedResponse,
    submitInvoiceError: state.invoices.submitInvoicedError,
    resendResponse: state.sap.resendResponse,
    resendLoading: state.sap.isResendFetchDataLoading,
    resendError: state.sap.resendPendingError,
    isResendError: state.sap.isResendFetchDataError,
    featureToggles: state.featureToggle.featureToggles,
    costAndrevenueresponse: state.costRevenue.response,
    isNftpBillable: state.exportJob.nftpBillableResponse?.isNftpBillable,
    isNftpBillableLoading: state.exportJob.isNftpBillableLoading
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, Action>): IMapDispatchToProps => ({
    fetchFCRDetails: (documentId: number) => dispatch(fetchFCRDetails(documentId)),
    fetchCostAndRevenue: (type: number, valueId: any, targetType: string) => dispatch(fetchCostAndRevenue(type, valueId, targetType)),
    fetchNftpBillable: (jobId: number) => dispatch(fetchNftpBillable(jobId))
});

export const _Documents = connect<IMapStateToProps, IMapDispatchToProps, {}, IStore>(mapStateToProps, mapDispatchToProps)(_ChargesDocumentDetails);
export const Documents = withRouter(_Documents);